import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer'>

        <div className='footer-info'>
            <div className='footer-info-logo'>
                <img src='/LogoWhite.png'></img>
            </div>
            <div className='footer-info-text'>
               © 2026 CARD ARMORY. EQUIPMENT FOR THE MODERN ADVENTURER. ALL RIGHTS RESERVED.
            </div>
        </div>

        <div className='footer-links'>

        <NavLink 
          to='/terminos-servicios' 
           className={"footer-link"}
        >
          Terminos y condiciones<span></span>
        </NavLink>

        <NavLink 
          to='/politica-de-privacidad' 
          className={"footer-link"}
        >
          Politicas de privacidad<span></span>
        </NavLink>

        {/* <NavLink 
          to='/inicio' 
          className={"footer-link"}
        >
          Vender productos<span></span>
        </NavLink> */}
        </div>



    </div>
  )
}

export default Footer